import React from 'react';
import PropTypes from 'prop-types';

import { Col, Form, Select } from 'antd';

import { fieldNames } from '../constants';
import { ExportTypesPropType } from '../propTypes';
import {
  StatePropType,
  stateHelper,
} from '../../../../../constants/stateMachineStates';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
  gutter: 24,
};

export const ExportsFormFirstBlock = ({ form, exportTypes, state }) => {
  const { getFieldDecorator } = form;
  return (
    <>
      <Col
        sm={24}
        md={{ offset: 4, span: 16 }}
      >
        <Form.Item
          label="Тип отчета"
          {...formItemLayout}
          {...(stateHelper.isSuccess(state) && !exportTypes?.length
            ? {
                validateStatus: 'error',
                help: 'Для вас нет доступных отчетов',
              }
            : {})}
        >
          {getFieldDecorator(fieldNames.exportTypeId, {
            rules: [
              {
                required: true,
                message: 'Выберите тип отчета',
              },
            ],
          })(
            <Select
              disabled={!exportTypes?.length}
              loading={stateHelper.isLoading(state)}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {(exportTypes || []).map((exportType) => (
                <Select.Option
                  value={exportType.id}
                  key={exportType.id}
                >
                  {exportType.name}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </Col>
    </>
  );
};

ExportsFormFirstBlock.propTypes = {
  form: PropTypes.object.isRequired,
  exportTypes: PropTypes.arrayOf(ExportTypesPropType).isRequired,
  state: StatePropType.isRequired,
};
